import PropTypes from 'prop-types'
import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 19px;
  height: 19px;
  color: #9b9b9b;
`

const View = ({ title = 'View', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 61 50" title={title} {...rest}>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-_viewList" fill="currentColor" fillRule="nonzero">
        <path
          d="M20,18 L1,18 C0.447,18 0,17.552 0,17 C0,16.448 0.447,16 1,16 L20,16 C20.553,16 21,16.448 21,17 C21,17.552 20.553,18 20,18 Z"
          id="Path"
        />
        <path
          d="M20,34 L1,34 C0.447,34 0,33.552 0,33 C0,32.448 0.447,32 1,32 L20,32 C20.553,32 21,32.448 21,33 C21,33.552 20.553,34 20,34 Z"
          id="Path"
        />
        <path
          d="M40,50 L1,50 C0.447,50 0,49.552 0,49 C0,48.448 0.447,48 1,48 L40,48 C40.553,48 41,48.448 41,49 C41,49.552 40.553,50 40,50 Z"
          id="Path"
        />
        <path
          d="M55,2 L1,2 C0.447,2 0,1.552 0,1 C0,0.448 0.447,0 1,0 L55,0 C55.553,0 56,0.448 56,1 C56,1.552 55.553,2 55,2 Z"
          id="Path"
        />
        <path
          d="M60.707,42.879 L50.607,32.779 C50.565,32.737 50.511,32.717 50.463,32.684 C52.05,30.528 53,27.876 53,25 C53,17.832 47.168,12 40,12 C32.832,12 27,17.832 27,25 C27,32.168 32.832,38 40,38 C42.876,38 45.528,37.05 47.683,35.463 C47.716,35.51 47.736,35.564 47.778,35.607 L57.878,45.707 C58.269,46.098 58.902,46.098 59.292,45.707 L60.706,44.293 C61.097,43.903 61.097,43.269 60.707,42.879 Z M29,25 C29,18.935 33.935,14 40,14 C46.065,14 51,18.935 51,25 C51,31.065 46.065,36 40,36 C33.935,36 29,31.065 29,25 Z"
          id="Shape"
        />
      </g>
    </g>
  </StyledIcon>
)

View.displayName = 'View'

View.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string
}

View.defaultProps = {
  onClick: () => {},
  title: 'View'
}

View.needsWork = true
export default View
